import type { Menu } from '@/bindings/Menu'
import type { MenuItem } from '@/bindings/MenuItem'

/** Mirrors `romi_domain::MAX_STOCK`: the daily stock input's `max`. */
export const MAX_STOCK = 1_000_000

/** The `step` attribute a price input needs to accept exactly `decimals` decimals. */
export function priceStep(decimals: number): string {
  return decimals === 0 ? '1' : `0.${'0'.repeat(decimals - 1)}1`
}

/** Items are unordered server-side (F2): grouped under their category, categories in position order. */
export function groupByCategory(menu: Menu): Map<string, MenuItem[]> {
  const groups = new Map<string, MenuItem[]>()
  for (const category of menu.categories) groups.set(category.id, [])
  for (const item of menu.items) groups.get(item.category_id)?.push(item)
  return groups
}
